import _ from 'lodash';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import { Redirect } from 'react-router';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

// import { Token } from 'models';

import {
  FooterBlock,
  Block,
  Content,
  NavBack,
  Title,
} from 'components/landing/components';


import mainConfig from 'config/config';
import config from 'config/login';

import IterioLogo from 'images/logo.svg';
import GoogleIcon from 'images/login/google.svg';
import FacebookIcon from 'images/login/facebook.svg';
import { SocialButton } from './socialButton';

import './Login.css';


const dumbLogin = dumbBem('l-login');
const LoginWrp = tx(dumbLogin)('div');

const PreFooterImg = tx([{ element: 'pre-footer' }, dumbLogin])('div');
const ButtonsWrp = tx([{ element: 'buttons-wrapper' }, dumbLogin])('div');
const LogoWrp = tx([{ element: 'logo-wrapper' }, dumbLogin])('div');

export class Login extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, ['onGoogleLogin', 'onFacebookLogin']);
  }

  render() {
    // if (Token.get()) { return <Redirect to='/console'/> }

    const page = this.props.location.pathname.match(/\/login/) ? 'login' : 'signup';
    const _config = config[page];

    return (
      <LoginWrp>
        <Block modifier="content">
          <NavBack onClick={() => this.props.history.goBack()}>
            back
          </NavBack>

          <PreFooterImg />

          <Content modifier="content">
            <LogoWrp>
              <img src={IterioLogo} alt="" />
            </LogoWrp>
            <ButtonsWrp>
              <SocialButton
                onClick={this.onFacebookLogin}
                modifier="facebook"
                text={_config.buttonGroup.facebook}
                img={FacebookIcon}
              />
              <SocialButton
                onClick={this.onGoogleLogin}
                modifier="google"
                text={_config.buttonGroup.google}
                img={GoogleIcon}
              />
            </ButtonsWrp>

            <Title modifier="4 footer">
              {_config.footer.title}
            </Title>

            <Link to={`/${page === 'login' ? 'signup' : 'login'}`}>
              <Title onClick={this.onAction} modifier="4 footer bold btn">
                {_config.footer.action}
              </Title>
            </Link>
          </Content>
        </Block>
        <FooterBlock />
      </LoginWrp>
    );
  }

  onGoogleLogin() {
    window.location = `${mainConfig.apiDomain}/google_login`;
  }

  onFacebookLogin() {
    window.location = `${mainConfig.apiDomain}/v1/facebook_login`;
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/login/Login.js